var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaderboardsBb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "scaling-svg",
    id: "welcome-bb",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 508 508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".leaderboardsbb-cls-1,.leaderboardsbb-cls-13,.leaderboardsbb-cls-4,.leaderboardsbb-cls-8{fill:#fff;}.leaderboardsbb-cls-1,.leaderboardsbb-cls-15,.leaderboardsbb-cls-16,.leaderboardsbb-cls-17{stroke:#63666a;}.leaderboardsbb-cls-1,.leaderboardsbb-cls-4{stroke-linecap:round;stroke-linejoin:round;}.leaderboardsbb-cls-1,.leaderboardsbb-cls-13,.leaderboardsbb-cls-3,.leaderboardsbb-cls-4{stroke-width:4px;}.leaderboardsbb-cls-11,.leaderboardsbb-cls-14,.leaderboardsbb-cls-17,.leaderboardsbb-cls-2,.leaderboardsbb-cls-3,.leaderboardsbb-cls-5{fill:none;}.leaderboardsbb-cls-2{stroke:#cdefff;stroke-width:10px;}.leaderboardsbb-cls-11,.leaderboardsbb-cls-12,.leaderboardsbb-cls-13,.leaderboardsbb-cls-14,.leaderboardsbb-cls-15,.leaderboardsbb-cls-16,.leaderboardsbb-cls-17,.leaderboardsbb-cls-2,.leaderboardsbb-cls-3,.leaderboardsbb-cls-5{stroke-miterlimit:10;}.leaderboardsbb-cls-3,.leaderboardsbb-cls-4,.leaderboardsbb-cls-5{stroke:#000;}.leaderboardsbb-cls-5{stroke-width:6px;}.leaderboardsbb-cls-6{fill:#99e0ff;}.leaderboardsbb-cls-10,.leaderboardsbb-cls-11,.leaderboardsbb-cls-7{isolation:isolate;}.leaderboardsbb-cls-10,.leaderboardsbb-cls-12,.leaderboardsbb-cls-15,.leaderboardsbb-cls-9{fill:#65b05d;}.leaderboardsbb-cls-10,.leaderboardsbb-cls-11{font-size:22.31px;font-family:Prelo-Book, Prelo;}.leaderboardsbb-cls-11,.leaderboardsbb-cls-12{stroke:#65b05d;}.leaderboardsbb-cls-13,.leaderboardsbb-cls-14{stroke:#fff;}.leaderboardsbb-cls-14{stroke-width:5px;}.leaderboardsbb-cls-15,.leaderboardsbb-cls-16,.leaderboardsbb-cls-17{stroke-width:3px;}.leaderboardsbb-cls-16{fill:#8cc486;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bb-grp"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bb-structure"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "leaderboardsbb-cls-1",
    x: 35.09,
    y: 57.29,
    width: 450,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    className: "leaderboardsbb-cls-1",
    x: 232.09,
    y: 308.29,
    width: 56,
    height: 154
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "leaderboardsbb-cls-1",
    points: "321.09 481.29 321.09 462.29 199.09 462.29 199.09 481.29"
  }), /*#__PURE__*/React.createElement("line", {
    className: "leaderboardsbb-cls-2",
    x1: 279.09,
    y1: 313.29,
    x2: 279.09,
    y2: 458.29
  })), /*#__PURE__*/React.createElement("g", {
    id: "bb-lights"
  }, /*#__PURE__*/React.createElement("line", {
    className: "leaderboardsbb-cls-3",
    x1: 256.09,
    y1: 19.29,
    x2: 256.09,
    y2: 43.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "leaderboardsbb-cls-3",
    x1: 177.09,
    y1: 19.29,
    x2: 186.75,
    y2: 43.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "leaderboardsbb-cls-3",
    x1: 97.09,
    y1: 19.29,
    x2: 117.42,
    y2: 43.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "leaderboardsbb-cls-3",
    x1: 18.09,
    y1: 19.29,
    x2: 48.09,
    y2: 43.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "leaderboardsbb-cls-4",
    points: "267.09 19.29 245.09 19.29 247.09 3.29 265.09 3.29 267.09 19.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "leaderboardsbb-cls-4",
    points: "187.75 19.29 165.75 19.29 167.75 3.29 185.75 3.29 187.75 19.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "leaderboardsbb-cls-4",
    points: "108.42 19.29 86.42 19.29 88.42 3.29 106.42 3.29 108.42 19.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "leaderboardsbb-cls-4",
    points: "29.09 19.29 7.09 19.29 9.09 3.29 27.09 3.29 29.09 19.29"
  }), /*#__PURE__*/React.createElement("line", {
    className: "leaderboardsbb-cls-3",
    x1: 335.09,
    y1: 19.29,
    x2: 325.42,
    y2: 43.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "leaderboardsbb-cls-3",
    x1: 415.09,
    y1: 19.29,
    x2: 394.75,
    y2: 43.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "leaderboardsbb-cls-3",
    x1: 494.09,
    y1: 19.29,
    x2: 464.09,
    y2: 43.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "leaderboardsbb-cls-4",
    points: "324.42 19.29 346.42 19.29 344.42 3.29 326.42 3.29 324.42 19.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "leaderboardsbb-cls-4",
    points: "403.75 19.29 425.75 19.29 423.75 3.29 405.75 3.29 403.75 19.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "leaderboardsbb-cls-4",
    points: "483.09 19.29 505.09 19.29 503.09 3.29 485.09 3.29 483.09 19.29"
  }), /*#__PURE__*/React.createElement("line", {
    className: "leaderboardsbb-cls-5",
    x1: 47.09,
    y1: 43.29,
    x2: 465.09,
    y2: 43.29
  })), /*#__PURE__*/React.createElement("g", {
    id: "bb-canvas"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    className: "leaderboardsbb-cls-6",
    x: 45.09,
    y: 67.3,
    width: 430,
    height: 231
  }), /*#__PURE__*/React.createElement("g", {
    id: "w-text",
    className: "leaderboardsbb-cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "leaderboardsbb-cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-8",
    d: "M87.19,100.07h-.08l-5.36,20.41H78.29L71.71,95.82h3L80.13,117h0l5.47-21.17h3.17L94.31,117h0l5.44-21.17h2.8L96,120.48H92.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "leaderboardsbb-cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-8",
    d: "M118.44,111.62H105.8q.11,6.91,6.45,6.92a19.4,19.4,0,0,0,5.61-.72l.33,2.05a23.21,23.21,0,0,1-6.3.79q-8.82,0-8.82-9.36t8.6-9.36q3.78,0,5.36,1.87a7.21,7.21,0,0,1,1.66,4.61A15.18,15.18,0,0,1,118.44,111.62Zm-6.91-7.7q-5.27,0-5.73,6H116a6.32,6.32,0,0,0,.14-2.13Q115.85,103.93,111.53,103.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-8",
    d: "M122.51,120.3V95.1H125v25.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "leaderboardsbb-cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-8",
    d: "M129.06,111.3q0-9.36,8.6-9.36a24.65,24.65,0,0,1,6,.79l-.47,2a22.24,22.24,0,0,0-5.54-.72,5.21,5.21,0,0,0-4.5,2,10.36,10.36,0,0,0,0,10.54,5.21,5.21,0,0,0,4.5,2,22.24,22.24,0,0,0,5.54-.72l.47,2.05a24.65,24.65,0,0,1-6,.79Q129,120.66,129.06,111.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "leaderboardsbb-cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-8",
    d: "M161.31,111.3q0,9.36-8.06,9.36t-8.06-9.36q0-9.36,8.06-9.36T161.31,111.3Zm-2.66,0q0-7.23-5.4-7.24t-5.4,7.24q0,7.23,5.4,7.24T158.65,111.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-8",
    d: "M167.87,106.48V120.3h-2.52v-18h2.52v2.63h.07c1.94-2,3.95-3,6-3q4,0,5,3.24a8.86,8.86,0,0,1,6.51-3.24q5.4,0,5.4,5.9V120.3h-2.52V108.38q0-4.32-4-4.32-2.19,0-5.11,2.49a15,15,0,0,1,.11,1.94V120.3h-2.52v-12q-.08-4.22-4-4.22a5,5,0,0,0-2,.47,9.27,9.27,0,0,0-1.57.83C168.93,105.6,168.47,106,167.87,106.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-8",
    d: "M210.24,111.62H197.6q.1,6.91,6.45,6.92a19.4,19.4,0,0,0,5.61-.72l.33,2.05a23.21,23.21,0,0,1-6.3.79q-8.83,0-8.82-9.36t8.6-9.36q3.78,0,5.36,1.87a7.21,7.21,0,0,1,1.66,4.61A15.18,15.18,0,0,1,210.24,111.62Zm-6.91-7.7q-5.27,0-5.73,6h10.19a6.32,6.32,0,0,0,.14-2.13Q207.65,103.93,203.33,103.92Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "leaderboardsbb-cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-8",
    d: "M222.22,115V104.14h-2.85v-1.66l2.85-.18.32-5h2.2v5h5.32v1.84h-5.32v10.47a5.08,5.08,0,0,0,.72,3,3,3,0,0,0,2.55,1,11.56,11.56,0,0,0,2-.18l.25,2a19.89,19.89,0,0,1-3,.25,5,5,0,0,1-3.83-1.28C222.61,118.53,222.22,117.07,222.22,115Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "leaderboardsbb-cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-8",
    d: "M248.06,111.3q0,9.36-8.06,9.36t-8.06-9.36q0-9.36,8.06-9.36T248.06,111.3Zm-2.66,0q0-7.23-5.4-7.24t-5.4,7.24q0,7.23,5.4,7.24T245.4,111.3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "pop-text",
    className: "leaderboardsbb-cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "leaderboardsbb-cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-9",
    d: "M214.29,269.72H209.8v6.36h-1.65V260.91h6.14a4.41,4.41,0,0,1,3.33,1.23,4.9,4.9,0,0,1,0,6.4A4.53,4.53,0,0,1,214.29,269.72Zm-4.49-7.34v5.87h4.33a3.11,3.11,0,0,0,2.21-.74,2.86,2.86,0,0,0,.78-2.18,2.92,2.92,0,0,0-.8-2.16,3,3,0,0,0-2.19-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-9",
    d: "M230.24,270.5q0,5.81-5,5.8t-5-5.8c0-3.86,1.66-5.8,5-5.8S230.24,266.64,230.24,270.5Zm-1.65,0q0-4.49-3.35-4.48t-3.34,4.48q0,4.49,3.34,4.49T228.59,270.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-9",
    d: "M234.41,264.92V266h.05A5,5,0,0,1,238,264.7c2.79,0,4.18,1.94,4.18,5.8a7.7,7.7,0,0,1-1,4.23,3.55,3.55,0,0,1-3.22,1.57,4.93,4.93,0,0,1-3.48-1.29h-.05v5.53h-1.56V264.92Zm6.12,5.58q0-4.49-3.11-4.48a4.6,4.6,0,0,0-3,1.07v6.83a4.6,4.6,0,0,0,3,1.07Q240.53,275,240.53,270.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-9",
    d: "M252.33,273.49v-8.57h1.56v11.16h-1.56v-1.61h-.05a6,6,0,0,1-4.15,1.83q-3.34,0-3.34-3.66v-7.72h1.56v7.39c0,1.78.82,2.68,2.45,2.68A5.86,5.86,0,0,0,252.33,273.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-9",
    d: "M256.72,276.08V260.46h1.56v15.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-9",
    d: "M265.33,266a18.27,18.27,0,0,0-3.57.4l-.24-1.27a21.57,21.57,0,0,1,4.15-.45,4.72,4.72,0,0,1,3,.8,3.55,3.55,0,0,1,1,2.86v7.72H268.1V275h0a5.56,5.56,0,0,1-3.64,1.34,3.87,3.87,0,0,1-2.66-.87,3,3,0,0,1-1-2.34q0-3.37,4.69-3.37h2.63v-1.27a2.37,2.37,0,0,0-.65-1.85A3.11,3.11,0,0,0,265.33,266Zm2.77,8v-3.3h-2.54a4.13,4.13,0,0,0-2.48.58,2,2,0,0,0-.74,1.68,1.9,1.9,0,0,0,.71,1.54,3,3,0,0,0,1.95.58A4.8,4.8,0,0,0,268.1,274Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-9",
    d: "M273.39,272.8v-6.74h-1.77v-1l1.77-.12.2-3.12H275v3.12h3.3v1.14H275v6.49a3.13,3.13,0,0,0,.45,1.89A1.83,1.83,0,0,0,277,275a7.79,7.79,0,0,0,1.23-.11l.15,1.23a13,13,0,0,1-1.87.15,3.1,3.1,0,0,1-2.38-.79A4,4,0,0,1,273.39,272.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-9",
    d: "M281,260.91h1.57v2.65H281Zm0,4h1.57v11.16H281Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-9",
    d: "M295.14,270.5q0,5.81-5,5.8t-5-5.8c0-3.86,1.67-5.8,5-5.8S295.14,266.64,295.14,270.5Zm-1.65,0q0-4.49-3.35-4.48t-3.35,4.48q0,4.49,3.35,4.49T293.49,270.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-9",
    d: "M299.31,267.51v8.57h-1.56V264.92h1.56v1.63h.05a5.88,5.88,0,0,1,4.14-1.85c2.24,0,3.35,1.22,3.35,3.66v7.72h-1.56V268.7c0-1.79-.82-2.68-2.45-2.68A5.91,5.91,0,0,0,299.31,267.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-9",
    d: "M309.69,265.82h1.56v2.74h-1.56Zm0,7.54h1.56v2.72h-1.56Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "leaderboardsbb-cls-10",
    transform: "translate(315.48 276.08)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "leaderboardsbb-cls-11",
    transform: "translate(315.48 276.08)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "leaderboardsbb-cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-12",
    d: "M332.89,253.94v-.07H321.34V251.6h14.32v1.84q-7.77,12.71-9.36,22.64h-2.8a45.32,45.32,0,0,1,3.52-11.2A75.33,75.33,0,0,1,332.89,253.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-12",
    d: "M353.3,264.52l-.07,0a7.27,7.27,0,0,1-6.08,3.49,7,7,0,0,1-5.49-2.21,9.11,9.11,0,0,1-2-6.25,8.28,8.28,0,0,1,2.19-6,7.5,7.5,0,0,1,5.58-2.23,8.61,8.61,0,0,1,3.39.63,6.59,6.59,0,0,1,2.39,1.66,8.21,8.21,0,0,1,1.51,2.5,13.41,13.41,0,0,1,.83,3,22,22,0,0,1,.23,3.35,25.35,25.35,0,0,1-.77,6.7,10.61,10.61,0,0,1-2.2,4.37,8.61,8.61,0,0,1-3.15,2.27,10.16,10.16,0,0,1-3.88.7,19.23,19.23,0,0,1-5.37-.86l.36-2a18.27,18.27,0,0,0,4.79.72,6.67,6.67,0,0,0,3.65-1,6.6,6.6,0,0,0,2.4-2.58,14.35,14.35,0,0,0,1.22-3.13A13.16,13.16,0,0,0,353.3,264.52Zm-.21-2.08q.36-9.08-5.44-9.08a5,5,0,0,0-3.76,1.64,6.36,6.36,0,0,0-1.53,4.52,9.87,9.87,0,0,0,.23,2.16,7.22,7.22,0,0,0,.8,2,3.93,3.93,0,0,0,1.69,1.55,6,6,0,0,0,2.72.57C349.81,265.78,351.58,264.67,353.09,262.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-12",
    d: "M372.78,275.45a9.15,9.15,0,0,1-8.28,0,6.6,6.6,0,0,1-2.61-2.84,15.15,15.15,0,0,1-1.3-4,29,29,0,0,1-.38-4.93,27.8,27.8,0,0,1,.38-4.84,14,14,0,0,1,1.3-3.89,6.46,6.46,0,0,1,2.61-2.74,9.5,9.5,0,0,1,8.28,0,6.46,6.46,0,0,1,2.61,2.74,14,14,0,0,1,1.3,3.89,27.87,27.87,0,0,1,.37,4.84,29.05,29.05,0,0,1-.37,4.93,15.15,15.15,0,0,1-1.3,4A6.6,6.6,0,0,1,372.78,275.45Zm-1.26-21.26a5,5,0,0,0-7.54,2.34,14.51,14.51,0,0,0-.85,3.22,26.86,26.86,0,0,0-.25,3.91q0,10.65,5.76,10.66t5.76-10.66a28.35,28.35,0,0,0-.25-3.91,14.51,14.51,0,0,0-.85-3.22A4.93,4.93,0,0,0,371.52,254.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-12",
    d: "M382.68,280.76h-.9l.61-4.68h-.93v-4.39H384v4.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-12",
    d: "M400.93,275.45a9.15,9.15,0,0,1-8.28,0,6.6,6.6,0,0,1-2.61-2.84,14.78,14.78,0,0,1-1.29-4,28,28,0,0,1-.38-4.93,26.85,26.85,0,0,1,.38-4.84,13.7,13.7,0,0,1,1.29-3.89,6.46,6.46,0,0,1,2.61-2.74,9.5,9.5,0,0,1,8.28,0,6.46,6.46,0,0,1,2.61,2.74,14,14,0,0,1,1.3,3.89,27.87,27.87,0,0,1,.37,4.84,29.05,29.05,0,0,1-.37,4.93,15.15,15.15,0,0,1-1.3,4A6.6,6.6,0,0,1,400.93,275.45Zm-1.26-21.26a5.41,5.41,0,0,0-5.76,0,5,5,0,0,0-1.78,2.34,14.51,14.51,0,0,0-.85,3.22,28.35,28.35,0,0,0-.25,3.91q0,10.65,5.76,10.66t5.76-10.66a26.86,26.86,0,0,0-.25-3.91,14.51,14.51,0,0,0-.85-3.22A4.93,4.93,0,0,0,399.67,254.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-12",
    d: "M422.17,275.45a9.15,9.15,0,0,1-8.28,0,6.6,6.6,0,0,1-2.61-2.84,14.78,14.78,0,0,1-1.29-4,28,28,0,0,1-.38-4.93,26.85,26.85,0,0,1,.38-4.84,13.7,13.7,0,0,1,1.29-3.89,6.46,6.46,0,0,1,2.61-2.74,9.5,9.5,0,0,1,8.28,0,6.46,6.46,0,0,1,2.61,2.74,13.71,13.71,0,0,1,1.3,3.89,27.8,27.8,0,0,1,.38,4.84,29,29,0,0,1-.38,4.93,14.8,14.8,0,0,1-1.3,4A6.6,6.6,0,0,1,422.17,275.45Zm-1.26-21.26a5.41,5.41,0,0,0-5.76,0,5,5,0,0,0-1.78,2.34,14.51,14.51,0,0,0-.85,3.22,28.35,28.35,0,0,0-.25,3.91q0,10.65,5.76,10.66t5.76-10.66a26.86,26.86,0,0,0-.25-3.91,14.51,14.51,0,0,0-.85-3.22A4.93,4.93,0,0,0,420.91,254.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-12",
    d: "M443.41,275.45a9.15,9.15,0,0,1-8.28,0,6.6,6.6,0,0,1-2.61-2.84,15.15,15.15,0,0,1-1.3-4,29.05,29.05,0,0,1-.37-4.93,27.87,27.87,0,0,1,.37-4.84,14,14,0,0,1,1.3-3.89,6.46,6.46,0,0,1,2.61-2.74,9.5,9.5,0,0,1,8.28,0,6.46,6.46,0,0,1,2.61,2.74,14,14,0,0,1,1.3,3.89,27.8,27.8,0,0,1,.38,4.84,29,29,0,0,1-.38,4.93,15.15,15.15,0,0,1-1.3,4A6.6,6.6,0,0,1,443.41,275.45Zm-1.26-21.26a5,5,0,0,0-7.54,2.34,14.51,14.51,0,0,0-.85,3.22,26.86,26.86,0,0,0-.25,3.91q0,10.65,5.76,10.66T445,263.66a26.86,26.86,0,0,0-.25-3.91,14.51,14.51,0,0,0-.85-3.22A4.93,4.93,0,0,0,442.15,254.19Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "leaderboardsbb-cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-13",
    d: "M96.4,199.63h.08l16-47.44h6.24L99.92,207H92.56l-19.28-54.8h6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-13",
    d: "M127.44,152.19H133v5.52h-5.6Zm0,14.4H133v40h-5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-13",
    d: "M176.64,195.55q0,5.69-3.68,8.76t-10.64,3.08a69.73,69.73,0,0,1-16.72-1.76l1-4.56a61.36,61.36,0,0,0,15,1.76,13.69,13.69,0,0,0,4.24-.6,8.21,8.21,0,0,0,2.76-1.4A7.25,7.25,0,0,0,170.2,199a5.52,5.52,0,0,0,.72-1.76,8.26,8.26,0,0,0,.12-1.36,5.13,5.13,0,0,0-2.12-4.16q-2.13-1.68-8-2.88-7.05-1.28-10.8-4t-3.76-8.28c0-3.52,1.22-6.2,3.68-8s6-2.76,10.64-2.76a64.58,64.58,0,0,1,15.6,1.76l-1,4.56A58,58,0,0,0,161,170.35a14.36,14.36,0,0,0-4.92.72,5.64,5.64,0,0,0-2.76,1.84,7.41,7.41,0,0,0-1.08,2,4.86,4.86,0,0,0-.28,1.56,5.56,5.56,0,0,0,2,4.32q1.95,1.75,7.64,2.88,7.59,1.6,11.32,4.12T176.64,195.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-13",
    d: "M189.2,152.19h5.6v5.52h-5.6Zm0,14.4h5.6v40h-5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-13",
    d: "M243.6,186.59q0,20.81-17.92,20.8t-17.92-20.8q0-20.81,17.92-20.8T243.6,186.59Zm-5.92,0q0-16.08-12-16.08t-12,16.08q0,16.08,12,16.08T237.68,186.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-13",
    d: "M262.16,175.87v30.72h-5.6v-40h5.6v5.84h.16q6.87-6.65,14.88-6.64,12,0,12,13.12v27.68h-5.6V180.11q0-9.6-8.8-9.6Q268.95,170.51,262.16,175.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-13",
    d: "M320.88,207h-6.8l-15.2-40.4h6.32l12.32,34h.16l12.4-34h6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-13",
    d: "M348.8,152.19h5.6v5.52h-5.6Zm0,14.4h5.6v40h-5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-13",
    d: "M368.16,206.59v-56h5.6v56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-13",
    d: "M387.51,206.59v-56h5.61v56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-13",
    d: "M440.23,187.31H412.15q.24,15.36,14.32,15.36a43.14,43.14,0,0,0,12.48-1.6l.72,4.56a51.66,51.66,0,0,1-14,1.76q-19.59,0-19.6-20.8t19.12-20.8q8.4,0,11.92,4.16a15.94,15.94,0,0,1,3.68,10.24A33.09,33.09,0,0,1,440.23,187.31Zm-15.36-17.12q-11.67,0-12.72,13.44h22.64a14.4,14.4,0,0,0,.32-4.72Q434.48,170.2,424.87,170.19Z"
  })), /*#__PURE__*/React.createElement("line", {
    id: "line",
    className: "leaderboardsbb-cls-14",
    x1: 350.09,
    y1: 225.79,
    x2: 44.09,
    y2: 225.79
  })), /*#__PURE__*/React.createElement("path", {
    id: "bush",
    className: "leaderboardsbb-cls-15",
    d: "M357.33,490.29v-.78a13.35,13.35,0,0,0-20.58-11.23,11.77,11.77,0,0,0-23.15-.69,9.24,9.24,0,0,0-5-1.44,9.43,9.43,0,0,0-9.3,7.92,7.88,7.88,0,0,0-1.18.21,7,7,0,0,0-12.66,6h0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "tree0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-16",
    d: "M86.67,368.81a32.18,32.18,0,0,0-63.84,4.8,32.2,32.2,0,1,0,35.84,51.91,32.18,32.18,0,1,0,28-56.71Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "leaderboardsbb-cls-17",
    x1: 57.13,
    y1: 513.29,
    x2: 57.13,
    y2: 414.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "leaderboardsbb-cls-17",
    x1: 35.91,
    y1: 421.31,
    x2: 57.13,
    y2: 442.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "leaderboardsbb-cls-17",
    x1: 57.13,
    y1: 463.76,
    x2: 70.11,
    y2: 450.79
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "tree1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "leaderboardsbb-cls-16",
    d: "M468.92,422.36a12.73,12.73,0,0,0-8.81-12.11,22.18,22.18,0,0,0-9.72-23.87,12.72,12.72,0,1,0-23.68,0,22.22,22.22,0,0,0-9.66,24.14,12.73,12.73,0,0,0-2.16,22.57,12.72,12.72,0,0,0,15.88,18.23A20.51,20.51,0,0,0,464.45,432,12.74,12.74,0,0,0,468.92,422.36Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "leaderboardsbb-cls-17",
    x1: 440.19,
    y1: 495,
    x2: 440.19,
    y2: 424.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "leaderboardsbb-cls-17",
    x1: 440.19,
    y1: 432.21,
    x2: 449.84,
    y2: 422.56
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardsBb);
export default __webpack_public_path__ + "static/media/leaderboards-bb.aefe8535eadccc10f3aaf0a6e0a03f3d.svg";
export { ForwardRef as ReactComponent };